import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Dropdown, DropdownButton, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { faCopy} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import CurrencyCardIcon from '../utils/currency-card-icon.js';


import ClaimScanView from '../claim/claim-scan-view.js'

class BountyView extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;

		this.dataobject = null;

		this.bounty = null;

		
		let title = '';
		let wanted = '';
		let amount = 0;
		let currency = {symbol: ''};
		let currencies= [];
		let signingkey = null;
		let maincard = null;
		let bountycard = null;
		let isBountyPaused = false;
		let bountycard_balance_int = 0;
		let bountycard_balance_string = '';
		
		this.state = {
				title,
				wanted,
				amount,
				currency,
				currencies,
				signingkey,
				maincard,
				isBountyPaused,
				bountycard,
				bountycard_balance_int,
				bountycard_balance_string,
				isOwner: false,
				loaded: false,
				registration_text: 'loading...',
				message_text: 'loading...',
				sharelinkmessage: 'loading...',
				sharelink: 'loading...'
		}
	}


	
	// post render commit phase
	componentDidMount() {
		console.log('BountyView.componentDidMount called');
		
		let mvcmyquote = this.getMvcMyQuoteObject();

		let registration_text = mvcmyquote.t('This bounty has been registered.');

		let message_text = mvcmyquote.t(
			'You can claim the reward from the issuer by providing the information requested for this bounty. \
			If you haven\'t yet provided a private key for the corresponding currency, \
			you will be asked to enter the address of the account where you want to receive the funds. \
			If you provide a private key, it will be crypted and stored on your device, it will not leave \
			your device at any time and will not be shared with anyone. \
			Your claim will then be registered and be accessible to the issuer clicking on \
			the link that has been generated. \
			Send this link to the issuer to complete your claim.');
	
		let sharelinkmessage = mvcmyquote.t('You can share this bounty with the following link:');
		
		
		this.setState({registration_text, message_text, sharelinkmessage});

		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}

	async _countClaims() {
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let bounty = this.bounty;
		let bountyhash = bounty.txhash;
		let currencyuuid = bounty.currencyuuid;

		let claims = [];
		let claimscounts = [];

		claimscounts.total = 0;

		let canfetch = await mvcmyquote.canFetchTransactions(rootsessionuuid, walletuuid, currencyuuid);

		if (canfetch) {
			claims = await mvcmyquote.fetchClaims(rootsessionuuid, walletuuid, currencyuuid, bountyhash)
			.catch(err => {
				console.log('error in ClaimScanView._scan: ' + err);
			});

			for (var i = 0; i < (claims ? claims.length : 0); i++) {
				if (claimscounts[claims[i].status] !== undefined)
					claimscounts[claims[i].status]++;
				else
					claimscounts[claims[i].status] = 1;

				claimscounts.total++;
			}

		}

		return claimscounts;
	}


	async checkNavigationState() {
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let app_nav_state = this.app.getNavigationState();
		let app_nav_target = app_nav_state.target;

		// check wallet is unlocked
 		let unlocked = await this.app.checkWalletUnlocked()
		.catch(err => {
		});

		if (!unlocked) {
			// we open the default device wallet
			let devicewallet = await this.app.openDeviceWallet()
			.catch(err => {
			});

			walletuuid = devicewallet.uuid;

			this.setState({isdevicewallet: true});

		}
		else {
			let isdevicewallet = await this.app.isDeviceWallet(walletuuid);

			this.setState({isdevicewallet});
		}
		

		if (app_nav_target && (app_nav_target.route == 'bounty') && (app_nav_target.reached == false)) {
			var params = app_nav_target.params;
			var dataobj = params.dataobject;

			if (dataobj && (dataobj.type === 'bounty') && (dataobj.treated !== true)) {
				this.dataobject = dataobj;

				let txhash = params.txhash;

				let currencyuuid = dataobj.currencyuuid;

				// we fetch the bounty to have a proper record
				let bounty = await mvcmyquote.fetchBounty(rootsessionuuid, walletuuid, currencyuuid, txhash);
				this.bounty = bounty;

				let amount = bounty.amount;

				// time
				let registration_text = mvcmyquote.t('This bounty has been registered on');

				registration_text += ' ' + mvcmodule.formatDate(bounty.blocktime, 'YYYY-mm-dd HH:MM:SS') + '.';
				
	
				// share link
				let currency = await mvcmyquote.getCurrencyFromUUID(rootsessionuuid, currencyuuid)
				.catch(err => {
					console.log('error in BountyView.checkNavigationState: ' + err);
				});

				if (!currency)
					return Promise.reject('could not find currency ' + currencyuuid);
	
				var sharelink = await this.app.getShareLink(txhash, currency.uuid);
	

				// look if a wallet is open
				let maincard = null;
				let bountycard = null;
				let isBountyPaused = false;
				let bountycard_balance_int = 0;
				let bountycard_balance_string = '';
				let isOwner = false;

				let unlocked = await this.app.checkWalletUnlocked()
				.catch(err => {
				});

				if (unlocked) {
					var scheme = await mvcmyquote.getCurencySchemeInfo(rootsessionuuid, currencyuuid);

					maincard = await this.app.openCurrencyCard(currencyuuid)
					.catch(err => {
						console.log('error in BountyView.checkNavigationState: ' + err);
					});

					// is it the bounty owner
					let decryptcard = await mvcmyquote.getWalletDecryptingCard(rootsessionuuid, walletuuid, bounty.owner);
					if (decryptcard) {
						isOwner = true;
					}

					// get the bounty card
					let bountycardaddress = bounty.bounty_card_address;

					bountycard = await mvcmyquote.getCurrencyCardWithAddress(rootsessionuuid, walletuuid, currencyuuid, bountycardaddress)
					.catch(err => {
						console.log('error in BountyView.checkNavigationState: ' + err);
					});

					if (bountycard) {
						let pos = await mvcmyquote.getCurrencyPosition(rootsessionuuid, walletuuid, currencyuuid, bountycard.uuid);
				
						if (pos !== undefined) {
							bountycard_balance_int = await pos.toInteger();
							bountycard_balance_string = await mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, pos);
						}
	
						if (isOwner) {
							let bountycard_privatekey = await mvcmyquote.getCardPrivateKey(rootsessionuuid, walletuuid, bountycard.uuid)
							.catch(err => {});

							if ((!bountycard_privatekey) && (decryptcard)) {
								// if we don't have the private key on this device
								// we decrypt the card privatekey in the bounty record
								bountycard_privatekey = await mvcmyquote.aesDecryptString(rootsessionuuid, walletuuid, decryptcard.uuid, bounty.bounty_card_private_key_encrypted);

								if (bountycard_privatekey) {
									console.log('setting bounty card private key from encrypted info saved in pretrade');
									await mvcmyquote.setCardPrivateKey(rootsessionuuid, walletuuid, bountycard.uuid, bountycard_privatekey).catch(err => {});
								}
							}
						}
		
					}

					// counts claims
					let claimscounts = await this._countClaims()
					.catch(err => {
						console.log('error in BountyView.checkNavigationState: ' + err);
					});

					if (claimscounts) {
						// total - paid - rejected
						let claimspaid = (claimscounts[10] ? claimscounts[10] : 0);
						let claimsrejected = (claimscounts[-10] ? claimscounts[-10] : 0);
							let num_claims_out = claimscounts.total - claimsrejected - claimspaid;

						let token_amount_out = await mvcmyquote.getCurrencyAmount(rootsessionuuid, currencyuuid, amount);
						token_amount_out.multiply(num_claims_out);
						let token_amount_out_int= await token_amount_out.toInteger();

						if (token_amount_out_int >= bountycard_balance_int) {
							// if number of open claims * amount is higher than the bounty balance
							// we mark as paused
							isBountyPaused = true;
						}
					}
	
				}

				this.setState({amount, currency, isOwner, 
					maincard,
					isBountyPaused, 
					bountycard, bountycard_balance_int, bountycard_balance_string, 
					registration_text, sharelink});

				dataobj.viewed = true;
			}

			// mark target as reached
			app_nav_target.reached = true;
		}

		if (this.bounty) {
			let bounty = this.bounty;

			let title = bounty.title;
			let wanted = bounty.wanted;

			this.setState({title, wanted});
		}

		this.setState({loaded: true});
	}

 	// end of life
	componentWillUnmount() {
		console.log('BountyView.componentWillUnmount called');
		
		this.app.closeDeviceWallet();
	}
	
	
	// user actions
	async onSubmit() {
		console.log('onSubmit pressed!');
		
		if (this.dataobject) {
			let params = {action: 'create', txhash: this.dataobject.txhash, currencyuuid: this.dataobject.currencyuuid, dataobject: this.dataobject};
			this.app.gotoRoute('claim', params);
		}
		else
			this.app.alert('Bounty parameters not found');

		return true;
	}

	async onShareLinkClick() {
		const {sharelink} = this.state;
		
		// create a textarea on the fly, then remove it to
		// be able to copy to clipboard
		var textArea = document.createElement("textarea");
		textArea.value = sharelink;

		document.body.appendChild(textArea);
		textArea.select();
		document.execCommand("Copy");
		textArea.remove();

		this.app.alert("Share link has been copied to clipboard");
	}

	
	// rendering
	renderBountyCardPart() {
		let {currency, bountycard, bountycard_balance_string} = this.state;

		return (
			<div>
			{(bountycard ?
				<FormGroup className="CurrencyCard" controlId="address">
				<span className="CardIconCol">
					<CurrencyCardIcon
						app={this.app}
						currency={currency}
						card={bountycard}
					/>
				</span>
				<span className="CardBalanceCol">
					<FormLabel>Bounty Balance</FormLabel>
					<FormControl
						className="CardBalanceCol"
						disabled
						autoFocus
						type="text"
						value={bountycard_balance_string}
					/>
				</span>
				</FormGroup> :
				<></>
			)}
			</div>
		);
	}

	renderRegisterClaimButton() {
		let { loaded, isBountyPaused, bountycard_balance_int} = this.state;

		if (loaded) {
			return(
				<span>
				{(bountycard_balance_int ?
				(isBountyPaused ?
				<Button disabled type="submit">
					Bounty paused
				</Button> :
				<Button onClick={this.onSubmit.bind(this)} type="submit">
				  Register a claim
				</Button>) :
				<Button disabled type="submit">
					Bounty closed
				</Button>)}
				</span>);
		}
		else {
			return(	
				<Button disabled type="submit">
					loading...
				</Button>
			);
		}
	}


	renderBountyView() {
		let { loaded, title, wanted, amount, currency, registration_text, message_text, sharelinkmessage, sharelink, isOwner } = this.state;
		
		return (
			<div className="Form">
				<FormGroup controlId="title">
				  <FormLabel>Bounty Title</FormLabel>
				  <FormControl
					disabled
					autoFocus
					type="text"
					value={title}
					onChange={e => this.setState({title: e.target.value})}
				  />
				</FormGroup>

				<FormGroup controlId="wanted">
				  <FormLabel>Wanted</FormLabel>
				  <FormControl 
					disabled
					as="textarea" 
					rows="5" 
					autoFocus
					type="text"
					value={wanted}
					onChange={e => this.setState({wanted: e.target.value})}
				  />
				</FormGroup>
				
				<FormGroup className="Proposal" controlId="proposal">
				<span className="ProposalCol">
				<FormLabel>Amount</FormLabel>
				  <FormControl 
					disabled
					autoFocus
					type="text"
					value={amount}
					onChange={e => this.setState({amount: e.target.value})}
				  />
				</span>
				<span className="ProposalCol">
				<FormLabel>Currency</FormLabel>
				<InputGroup>
					<FormControl 
						disabled
						autoFocus
						type="text"
						value={currency.symbol}
						onChange={e => this.onChangeCurrency(e)}
					/>
				</InputGroup>
				 </span>
				</FormGroup>

				{this.renderBountyCardPart()}

				<div className="TextBox">
				  {registration_text}
			  	</div>

				<div className="TextBox">
					<div>{sharelinkmessage}</div>
					<div className="ShareBlock">
					<span className="ShareLink" onClick={this.onShareLinkClick.bind(this)}>{sharelink}</span>
					<span className="ShareIcon" onClick={this.onShareLinkClick.bind(this)}><FontAwesomeIcon icon={faCopy} /></span>
					</div>
				</div>

				{this.renderRegisterClaimButton()}

				<div className="TextBox">
				  {message_text}
			  	</div>


				{(this.dataobject ?
				<div>
				<hr></hr>
				<div>
					<ClaimScanView app={this.app} bounty={this.dataobject} />
				</div>
				</div> :
				<></>
				)}
			</div>
		  );
	}

	render() {
		return (
			<div className="Container">
				<div className="Title">Bounty View</div>
				{ this.renderBountyView()}
			</div>
		  );
	}
	
}


// propTypes validation
BountyView.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
	currentwalletuuid: PropTypes.string,
	iswalletlocked: PropTypes.bool,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
		iswalletlocked: state.wallets.islocked,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {BountyView};
export default connect(mapStateToProps, mapDispatchToProps)(BountyView);

